var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVector4 = function SvgVector4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 300,
    fill: "none",
    viewBox: "-100 150 1347 1052"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vector-4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F76323",
    d: "M366.127 205.417 49.581 312.286a90 90 0 0 0-57.186 58.656l-69.53 224.598c-13.58 43.868 8.044 90.925 50.177 109.19L294.08 843.905c36.405 15.783 78.852 5.861 104.489-24.424l93.541-110.499a90 90 0 0 1 78.135-31.353l281.333 29.684a90 90 0 0 0 75.017-27.858L1121.76 471.85c40.51-43.084 29.16-112.853-22.9-140.888l-86.67-46.666a90 90 0 0 0-52.565-10.212l-238.532 26.395a90 90 0 0 1-39.732-4.543l-256.612-90.159a90 90 0 0 0-58.622-.36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vector-4_svg__a",
    width: 1627.38,
    height: 1050.65,
    x: -281.176,
    y: 0.688,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3275_24492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3275_24492",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_3275_24492",
    stdDeviation: 100
  })))));
};
export default SvgVector4;